import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as actions from '../actions/expenses.actions';
import { ExpensesSelectors } from '../selectors/expenses.selectors';
import {
  AllocatedExpense,
  Expenses,
  InitExpensesState,
  NewExpense,
  SelectedUserExpenses,
  UpdateExpense,
} from '../state/expenses.state';

@Injectable({
  providedIn: 'root',
})
export class ExpensesFacade {
  getExpenseShareTypes$ = this.selectors.getExpenseShareTypes$;
  allocationTableData$ = this.selectors.getAllocationTableData$;
  isNewExpenseSubmitProcessing$ =
    this.selectors.getIsNewExpenseSubmitProcessing$;
  updateExpenseSubmitProcessing$ =
    this.selectors.getUpdateExpenseSubmitProcessing$;
  deleteExpenseSubmitProcessing$ =
    this.selectors.getDeleteExpenseSubmitProcessing$;
  expenses$ = this.selectors.getExpenses$;
  expensesRequestStatus$ = this.selectors.getExpensesRequestStatus$;
  selectedExpense$ = this.selectors.getSelectedExpense$;
  selectedUserExpenses$ = this.selectors.getSelectedUserExpenses$;
  selectedUserExpensesRequestStatus$ =
    this.selectors.getSelectedUserExpensesRequestStatus$;
  selectedUserExpense$ = this.selectors.getSelectedUserExpense$;

  constructor(
    private store: Store<InitExpensesState>,
    private selectors: ExpensesSelectors,
  ) {}

  clearExpensesState() {
    this.store.dispatch(actions.clearExpensesState());
  }

  getExpenses() {
    this.store.dispatch(actions.getExpenses());
  }

  createNewExpense(newExpense: NewExpense) {
    this.store.dispatch(actions.createNewExpense({ newExpense }));
  }

  updateAllocatedExpenses(allocatedExpenses: AllocatedExpense[]) {
    this.store.dispatch(actions.updateAllocatedExpenses({ allocatedExpenses }));
  }

  selectedExpense(selectedExpense: Expenses) {
    this.store.dispatch(actions.selectedExpense({ selectedExpense }));
  }

  getExpenseTransactions() {
    this.store.dispatch(actions.getExpenseTransactions());
  }

  clearSelectedExpense() {
    this.store.dispatch(actions.clearSelectedExpense());
  }

  viewSelectedUserExpense(selectedUserExpense: SelectedUserExpenses) {
    this.store.dispatch(
      actions.viewSelectedUserExpense({ selectedUserExpense }),
    );
  }
  clearSelectedUserExpense() {
    this.store.dispatch(actions.clearSelectedUserExpense());
  }

  updateExpenseTransaction(payload: UpdateExpense) {
    this.store.dispatch(actions.updateExpenseTransaction({ payload }));
  }

  deleteExpenseTransaction(expenseId: number) {
    this.store.dispatch(actions.deleteExpenseTransaction({ expenseId }));
  }
}
